import { Box, MenuItem } from '@mui/material';
import { DialogTitle, CustomSelect, CustomTextArea, HorizontalForm } from '../../../common';

const AdditionalDataSection = ({
  selectedSubscriber,
  onInputChange,
  onSelectChange,
  isMobile,
  ivaConditions,
}) => {
  return (
    <Box>
      <DialogTitle showSeparator={false} sx={{ p: 0 }}>Datos Adicionales</DialogTitle>
      <HorizontalForm withBorder={false} sx={{ p: 1 }}>
        <Box sx={{ flex: 1, mr: isMobile ? 0 : 4 }}>
          <CustomSelect
            label="Condición IVA"
            name="uuid_iva_condition"
            value={selectedSubscriber.uuid_iva_condition || ''}
            onChange={onSelectChange}
            disabled
            size="medium"
          >
            {ivaConditions.map((iva) => (
              <MenuItem key={iva.uuid} value={iva.uuid}>
                {iva.description}
              </MenuItem>
            ))}
          </CustomSelect>
        </Box>
        {!isMobile && <Box sx={{ flex: 1 }} />}
      </HorizontalForm>
      <Box sx={{ mt: 2, p: 1 }}>
        <CustomTextArea
          label="Observaciones"
          name="observations"
          value={selectedSubscriber.observations || ''}
          onChange={onInputChange}
          minRows={3}
          maxRows={6}
          size="medium"
        />
      </Box>
    </Box>
  );
};

export default AdditionalDataSection;
